import { apiWebsiteSlice } from "@/redux/app/api/apiSlice";

// export interface SubCategory {
//   id: number;
//   name: string;
//   status: number;
// }

// export interface Category {
//   id: number;
//   name: string;
//   status: number;
//   sub_category: SubCategory[];
//   created_at: string;
//   updated_at: string;
// }

// export interface CategoriesResponse {
//   status: boolean;
//   message: string;
//   data: Category[];
// }

export interface SubCategory {
  id: number;
  name: string;
  status: number;
}

export interface Category {
  id: number;
  name: string;
  status: number;
  sub_categories: SubCategory[];
  created_at: string;
  updated_at: string;
}

export interface CategoriesResponse {
  status: boolean;
  message: string;
  data: Category[];
}

export const websiteApiSlice = apiWebsiteSlice.injectEndpoints({
  endpoints: (builder) => ({
    getAllBlogsWithFilters: builder.query({
      query: (params) => ({
        url: `api/filter/blog`,
        params: { ...params },
      }),
      providesTags: ["Website"],
    }),
    getAllUniversitiesWithFilters: builder.query({
      query: (params) => ({
        url: `api/filter/university`,
        params: { ...params },
      }),
      providesTags: ["Website"],
    }),
    getAllFacultiesWithFilters: builder.query({
      query: (params) => ({
        url: `api/filter/faculty`,
        params: { ...params },
      }),
      providesTags: ["Website"],
    }),
    getAllGeneralFacultiesWithFilters: builder.query({
      query: (params) => ({
        url: `api/filter/general-faculty?search=${params.search}`,
        params: { ...params },
      }),
      providesTags: ["Website"],
    }),
    getAllSpecialtiesWithFilters: builder.query({
      query: (params) => ({
        url: `api/filter/specialization`,
        params: { ...params },
      }),
      providesTags: ["Website"],
    }),
    getBlogCategories: builder.query<CategoriesResponse, { locale: string }>({
      query: ({locale}) => ({
        url: `${locale}/api/blog-category/ `,
      }),
      providesTags: ["Website"],
    }),
  }),
});

export const {
  useGetAllBlogsWithFiltersQuery,
  useGetAllUniversitiesWithFiltersQuery,
  useGetAllFacultiesWithFiltersQuery,
  useGetAllGeneralFacultiesWithFiltersQuery,
  useGetAllSpecialtiesWithFiltersQuery,
  useGetBlogCategoriesQuery,
} = websiteApiSlice;
